import { useContext, useEffect, useState } from "react"
import { IoGrid, IoList } from "react-icons/io5"
import { useTranslation } from "react-i18next"
import SelectBox from "components/Commons/SelectBox/SelectBox"
import SummaryOptions from "overrides/theme/entel/base/components/Summary/SummaryOptions"
// import { useEnv } from "hooks"
import Loading from "overrides/theme/entel/base/components/Commons/Loading/Loading"
// import { useOrderGrouped } from "overrides/theme/entel/base/hooks"

// import summary_status from "overrides/theme/entel/base/helpers/summary_status"
import usePostMiddlewareBff from "overrides/theme/entel/base/hooks/v4/usePostMiddlewareBff"
import SummaryPopupChanges from "overrides/theme/entel/base/components/Summary/SummaryPopupChanges"
import { AuthContext } from "context/context"
import { GlobalContext } from "context/context/GlobalContext"
import useScheduleResources from "overrides/theme/entel/base/hooks/v4/useScheduleResources"

const DashboardContent = (props: any) => {
  const {
    state: { user },
  } = useContext(AuthContext)
  const { schedules } = useContext(GlobalContext)
  let { data, class_modifier, title, select_value, event_set_select, select_options, state_machine_states } = props
  const { t } = useTranslation()
  const [view, set_view] = useState("block")
  const [data_status, set_data_status]: any = useState(null)
  const [loading, set_loading] = useState(false)
  const { post_middleware_query_action: post_middleware_query_action_bff } = usePostMiddlewareBff()
  const { post_list_schedule_action } = useScheduleResources()
  let endpoint_group = "count/sg/status"

  const event_set_view = (type_view: any) => {
    if (view !== type_view) set_view(type_view)
  }

  const fetch_data = async () => {
    set_loading(true)

    let data: any = {
      shippingTypes: [select_value],
      groupBy: {
        "_omnixStateMachine.currentState.state.name": {
          size: 50,
        },
      },
    }

    if (Boolean(user?.currentSources?.length)) {
      Object.assign(data, user?.currentSources?.includes("ALL") ? {} : { sourcesId: user?.currentSources })
    }

    if (Boolean(user?.type)) {
      if (user?.type === "moto") {
        if (Boolean(user?.courier)) {
          Object.assign(data, { emails: [user?.email] })
          Object.assign(data, { couriers: [user?.courier] })
        }
      }
    }

    const response = await post_middleware_query_action_bff(endpoint_group, data)
    let statusses = response?.data?.message["_omnixStateMachine.currentState.state.name"] || []

    statusses = statusses.map((status: any) => {
      const [key] = Object.keys(status)
      const [value] = Object.values(status)
      const _val = {
        status: key,
        title: key,
        optionCount: value,
        path: `/order/${select_value}/${key}`,
      }
      return _val
    })
    let sgs_counter = state_machine_states.map((state: any) => {
      const _count = statusses.find((_st: any) => _st?.status === state?.label) || {}
      return { ...state, ..._count }
    })

    if (Boolean(user?.type)) {
      if (user?.type === "moto") {
        const avalailable_moto_states = ["packed_and_ready_for_pickup", "delivered_to_courier", "in_transit"]
        sgs_counter = sgs_counter.filter((sg: any) => avalailable_moto_states.includes(sg?.id))
      }
    }

    set_data_status(
      sgs_counter.map((sg: any) => {
        if (Boolean(!sg?.optionCount)) {
          return {
            ...sg,
            status: sg?.label,
            title: sg?.label,
            optionCount: 0,
            path: `/order/${select_value}/${sg?.label}`,
          }
        }
        return sg
      }),
    )
    set_loading(false)
  }

  const get_schedules = async () => {
    set_loading(true)
    const res: any = await post_list_schedule_action({
      skipRecords: 0,
      maxRecords: 100,
      project: ["id", "deliveryType", "type", "shippingType"],
    })
    set_schedules_context(res?.data?.message?.records || [])
    set_loading(false)
  }

  const set_schedules_context = (data_schedules: any) => {
    schedules.dispatch(data_schedules)
    localStorage.setItem("SCHEDULES", JSON.stringify(data_schedules))
  }

  useEffect(() => {
    if (select_value !== null && Boolean(state_machine_states?.length)) {
      fetch_data()
    }
    get_schedules()
    //eslint-disable-next-line
  }, [select_value, state_machine_states])

  const template = (
    <>
      {data_status && (
        <SummaryPopupChanges
          shippingType={select_value}
          data_status={{ state: data_status, dispatch: set_data_status }}
          call_service_counter={fetch_data}
          user={user}
        />
      )}
      {loading && <Loading defaultOpened={true} />}
      <section
        className={`dashboard__content__children dashboard__content__children--${class_modifier} dashboard__content__children--${view}`}
      >
        <article className="dashboard__content__children__header">
          <div className="dashboard__content__children__header__title">
            <h3>{t(title)}</h3>
          </div>
          <div className="dashboard__content__children__header__options">
            <div
              className="dashboard__content__children__header__options__item dashboard__content__children__header__options__item--block"
              onClick={() => event_set_view("block")}
            >
              <p>{t("Vista Resumen")}</p> <IoGrid />
            </div>
            <div
              className="dashboard__content__children__header__options__item dashboard__content__children__header__options__item--list"
              onClick={() => event_set_view("list")}
            >
              <p>{t("Vista Lista")}</p> <IoList />
            </div>
          </div>
        </article>
        <article className="dashboard__content__children__filters">
          {!!select_options && (
            <>
              <p>{t("Filtrar por")}</p>
              <div className="dashboard__content__children__filters__select">
                <SelectBox options={select_options} onchange={event_set_select} defaultValue={select_options[0]} />
              </div>
            </>
          )}
        </article>
        <article className="dashboard__content__children__items">
          {!!data_status && <SummaryOptions summaryOptions={data_status} current_shipping_type={select_value} />}
          {!!data && <SummaryOptions summaryOptions={data} current_shipping_type={select_value} />}
        </article>
      </section>
    </>
  )

  return template
}

export default DashboardContent
